import styled from 'styled-components'
import React from 'react'
import theme from '@/src/config/theme'

interface CloseButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  active: boolean
}

export const CloseButton = (props: CloseButtonProps) => (
  <StyledButton
    className="p-1.5 hover:bg-red-50 rounded-lg transition-colors group snipcss0-1-1-6"
    title="Сбросить все"
    onClick={props.onClick}
    data-active={props.active}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round">
      <path d="M18 6 6 18"></path>
      <path d="m6 6 12 12"></path>
    </svg>
  </StyledButton>
)

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  border-radius: 5px;

  & > svg {
    width: 16px;
    color: ${theme.colors.gray10};
  }

  &:hover,
  &[data-active="true"] {
    background: ${theme.colors.errorLighten};

    & > svg {
      stroke: ${theme.colors.error};
    }
  }
`
